import { render, staticRenderFns } from "./NewInventoryForm.vue?vue&type=template&id=f37c4a44"
import script from "./NewInventoryForm.vue?vue&type=script&lang=js"
export * from "./NewInventoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports